"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityEncrypter = void 0;
var NAME = "IdentityEncrypter";
/**
 * "Encrypt" keys in a very basic, naive way.
 */
exports.IdentityEncrypter = {
    name: NAME,
    encryptKey: function (params) {
        var key = params.key;
        var type = key.type, privateKey = key.privateKey, publicKey = key.publicKey, path = key.path, extra = key.extra, props = __rest(key, ["type", "privateKey", "publicKey", "path", "extra"]);
        return Promise.resolve(__assign(__assign({}, props), { encryptedBlob: JSON.stringify({
                type: type,
                publicKey: publicKey,
                privateKey: privateKey,
                path: path,
                extra: extra,
            }), encrypterName: NAME, salt: "identity" }));
    },
    decryptKey: function (params) {
        var encryptedKey = params.encryptedKey;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        encryptedKey, encrypterName = _a.encrypterName, salt = _a.salt, encryptedBlob = _a.encryptedBlob, props = __rest(_a, ["encrypterName", "salt", "encryptedBlob"]);
        var data = JSON.parse(encryptedBlob);
        return Promise.resolve(__assign(__assign({}, props), data));
    },
};
